module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iFwj3"))).then(() => parcelRequire('hEqeo'));